import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { PartialLocation } from "common/types/routing";

import { getLastSession } from "seneca-common/features/session/selectors/session";

import { linkThroughQuitSessionModal } from "features/classroom/features/sidebar/features/common/utils/linkThroughQuitSessionModal";
import { useWarnOnNavigateAwayFromSession } from "features/classroom/hooks/useWarnOnNavigateAwayFromSession";

type Props = {
  courseId: string;
  activeSectionId: string;
  link: string | PartialLocation;
};

export default function useSectionRowQuitSessionLink({
  courseId,
  activeSectionId,
  link
}: Props): string | PartialLocation {
  const location = useLocation();

  const warnBeforeNavigation = useWarnOnNavigateAwayFromSession();

  const sessionType = useSelector(getLastSession)?.sessionType!;

  return linkThroughQuitSessionModal({
    warnBeforeNavigation,
    courseId,
    activeSectionId,
    sessionType,
    link,
    currentLocation: location
  });
}
